import jsPDF from 'jspdf';
import 'jspdf-autotable';
import HTTPRequest from '../../../controllers/httpRequest';
import secureStorage from '../../../controllers/secureStorage.js';
import moment from 'moment';
import { decrypt } from "../../../utilities.js"

var printOthsinWithholding = {
    methods: {
        async printOTHSINWithholding(isDefaultPrint, customFont, summaryData, component_x) {
            component_x.spinning = true;

            let tabulatorInstance = component_x.$refs.tabulator.getInstance();
            let tableData = tabulatorInstance.getData();
            let documentDetails = component_x.documentDetails;

            // console.log(`Printing OTHSIN with isDefaultPrint=${isDefaultPrint} and customFont=${customFont} and this ${component_x}`, component_x);
            // console.log(component_x.documentDetails, component_x);
            // console.log('tabledata',tableData)
            const doc = new jsPDF('p', 'pt', 'a4');
            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();
            const documentDate = moment(documentDetails.document_date, 'YYYY-MM-DD');
            const targetDate = moment(documentDetails.target_date, 'YYYY-MM-DD');
            const terms = documentDate.diff(targetDate, 'days');
            const accountName = secureStorage.getItem("accountName")
            const isPIML = accountName.toLowerCase().includes('piml')
            var documentHistory = await HTTPRequest.getRequest(component_x.endPoint + "document_action_histories/" + documentDetails.id + "?field_name=document_id", null);


            let xLeftKey = 35;
            let requestingSiteId = component_x.documentDetails.site_id.key;

            let siteData = await HTTPRequest.getRequest(`${component_x.endPoint}sites/${requestingSiteId}`, null, null);
            let companyData = await HTTPRequest.getRequest(`${this.endPoint}companies/${siteData.company_id}`, null, null);
            // let customer = await HTTPRequest.getRequest(`${component_x.endPoint}customers/${component_x.customer.key}`, null, null);
            let b2b = await HTTPRequest.getRequest(`${this.endPoint}b2b_customers/${this.b2bCustomer}`, null, null);
            const effectiveWtaxCode = documentDetails.wtax_code || (b2b && b2b.wtax_code) || null;
            const withholdingCodes = effectiveWtaxCode
                ? await HTTPRequest.getRequest(`${component_x.endPoint}accounts/wtax_codes?wtax_code=${encodeURIComponent(effectiveWtaxCode)}`, null, null)
                : [];
            const withholdingRate = Number(withholdingCodes && withholdingCodes[0] && withholdingCodes[0].percentage || 0);

            // since this is not being saved as country_id on b2b_customer on NS through lynexus > RMS, we need to map it here
            // Netsuite (via Lynexus integ -> RMS) saves `country_id` as ISO code (e.g. "DK")
            // Printout requires full country name, so we need to map codes here
            // first mapping from get_valid_countries API (active countries in RMS), then fallback to a hardcoded map for missing entries like DK -> DENMARK
            const FALLBACK_COUNTRY_MAP = {
                "DK": "DENMARK",
                // add more unmapped codes as needed
            };

            async function getCountryName(code, endPoint) {
                try {
                    let response = await HTTPRequest.getRequest(`${endPoint}countries/get_valid_countries`, null, null);
                    let countries = response || [];
                    let found = countries.find(c => c.code === code);

                    return found ? found.name : (FALLBACK_COUNTRY_MAP[code] || code || "");
                } catch (e) {
                    console.error("getCountryName error:", e);
                    return FALLBACK_COUNTRY_MAP[code] || code || "";
                }
            }

            let countryName = await getCountryName(b2b.country_id, this.endPoint);
            let street_or_province = b2b.province_name || "";
            let barangay = b2b.barangay_name || "";
            let city = b2b.city_name || "";
            let zip_code = b2b.zip_code || "";
            let address_1 = b2b.address || "";

            let formattedCustomerAddress = `${address_1}, ${barangay}, ${zip_code}, ${city}, ${street_or_province}, ${countryName}`;
            let isPrinted = false;

            // Check if any action in documentHistory is "Print Document"
            for (let i = 0; i < documentHistory.length; i++) {
                if (documentHistory[i].action === "Print Document") {
                    isPrinted = true;
                    break;
                }
            }

            // Function to add header
            function addHeader(doc, siteData, companyData, documentDetails, xLeftKey, pageWidth, pageNumber, pageCount) {
                // Title
                doc.setFontSize(12);
                doc.setFontStyle("bold");
                doc.text(`${siteData.company_name}`, xLeftKey, 30);

                // Subtitle
                // Per BIR layout: TIN is listed BEFORE the business address.
                doc.setFontSize(8);
                doc.setFontStyle("normal");
                let yPosition = 40;
                let lineHeight = 10;

                // 1) VAT REG TIN first
                doc.text(`VAT REG TIN: ${companyData.tin || ''}`, xLeftKey, yPosition);

                // 2) then the business address (can wrap into multiple lines)
                let companyAddress = doc.splitTextToSize(`${companyData.address || ''}`, 250);
                let addressStartY = yPosition + lineHeight;
                companyAddress.forEach((line, index) => {
                    doc.text(line, xLeftKey, addressStartY + (index * lineHeight));
                });

                // 3) then TEL. NO. below the address
                let companyDetailsY = addressStartY + (companyAddress.length * lineHeight);
                doc.text(`TEL. NO.: ${companyData.telephone || ''}`, xLeftKey, companyDetailsY);

                // Invoice Header
                const headerRightX = pageWidth - 40;

                // Per BIR layout: "INVOICE" is larger than "SALES". Draw them as two
                // parts on the same line, right-aligned so "INVOICE" ends at headerRightX
                // and "SALES " sits to its left.
                doc.setFontStyle("bold");
                doc.setFontSize(14);
                const invoiceWord = 'INVOICE';
                const invoiceWidth = doc.getTextWidth(invoiceWord);
                doc.text(invoiceWord, headerRightX, 45, { align: 'right' });
                doc.setFontSize(10);
                doc.text('SALES ', headerRightX - invoiceWidth, 45, { align: 'right' });

                // Document number (cas_no): bold and slightly larger per client request.
                doc.setFontSize(9);
                doc.setFontStyle("bold");
                doc.text(`${documentDetails.cas_no || ''}`, headerRightX, 60, { align: 'right' });
                doc.setFontSize(8);
                doc.setFontStyle("normal");
                doc.text(`${isPrinted ? 'REPRINTED' : 'ORIGINAL'} COPY`, headerRightX, 70, { align: 'right' });
            }

            // generate the first serial number from the prefix
            function generateFirstSerialNumber(casNo) {
                // split the cas_no to extract the prefix and current serial number
                const parts = casNo.split("-");
                const prefix = parts.slice(0, -1).join("-");
                const firstSerialNumber = `${prefix}-99999999`;
                return firstSerialNumber;
            }

            const currentSerialNumber = handleNull(documentDetails.cas_no);
            const firstSerialNumber = generateFirstSerialNumber(currentSerialNumber);

            // Function to add footer
            function addFooter(doc, pageWidth, pageHeight, pageNumber, pageCount) {
                const currentDate = moment().format('MM/DD/YYYY');
                const currentTime = moment().format('HH:mm');
                var userName = secureStorage.getItem("userName");

                doc.setFontSize(8);
                doc.setFontStyle("normal");
                doc.text(`Acknowledgement Certificate: ${handleNull(companyData.cas_permit_number)}`, 40, pageHeight - 50);
                doc.text(`Date Issued: ${moment(companyData.acknowledgement_receipt_date_issue).format("MMMM D, YYYY")}`, 40, pageHeight - 35);
                // doc.text(`Serial Number Range: ${currentSerialNumber + ' - ' + firstSerialNumber || ''}`, 40, pageHeight - 20);
                // Some companies have no configured series range, add fallback/guard against null/undefined values
                const seriesRange = handleNull(companyData.series_number_range);
                const seriesParts = String(seriesRange).split('-');
                const seriesStart = seriesParts[0] || '';
                const seriesEnd = seriesParts[1] || '';
                const companyCode = handleNull(documentDetails.company_code);
                doc.text(`Serial Number Range: ${'SI' + '-' + companyCode + '-' + seriesStart + ' - ' + 'SI' + '-' + companyCode + '-' + seriesEnd}`, 40, pageHeight - 20);
                // Old footer lines kept for reference (commented out per new format):
                // doc.text(`${userName}`, pageWidth - 40, pageHeight - 35, { align: 'right' });
                // doc.text(`${documentDetails.status}`, pageWidth - 40, pageHeight - 50, { align: 'right' });
                // doc.text(`${currentDate} ${currentTime}`, pageWidth - 40, pageHeight - 20, { align: 'right' });
                // doc.text(`Page ${pageNumber} of ${pageCount}`, pageWidth - 40, pageHeight - 35, { align: 'right' });

                // New format: "Prepared By: <user> (<posting date/time>)" on the bottom-right.
                const preparedBy = handleNull(documentDetails.posted_by_user_name || documentDetails.created_by_user_name || userName);
                const preparedAtRaw = documentDetails.posted_at || documentDetails.created_at;
                const preparedAt = preparedAtRaw ? moment(preparedAtRaw).format('MM/DD/YYYY HH:mm') : `${currentDate} ${currentTime}`;
                doc.setFontStyle("normal");
                doc.setTextColor(110, 110, 110);
                doc.text(`Prepared By: ${preparedBy} (${preparedAt})`, pageWidth - 40, pageHeight - 20, { align: 'right' });
                doc.setTextColor(0, 0, 0);
            }

            function handleNull(value) {
                return value == null ? '' : value;
            }

            function wrapTextToWidth(text, maxWidth) {
                const str = String(handleNull(text));
                if (!str) return [''];
                const lines = [];
                let current = '';
                for (const char of str) {
                    const candidate = current + char;
                    if (doc.getTextWidth(candidate) > maxWidth && current !== '') {
                        lines.push(current);
                        current = char;
                    } else {
                        current = candidate;
                    }
                }
                if (current !== '') lines.push(current);
                return lines.length ? lines : [''];
            }

            // Adjust the margin to 0.5 inch
            doc.setProperties({ margin: 0.1 * 72 }); // 0.5 inch in points
            doc.setFontSize(8);
            const infoTop = 98;
            const infoRowGap = 17;
            const infoLineHeight = 8;

            let customerName = handleNull(b2b.name) || "No Customer Name";
            let customerAddress = handleNull(formattedCustomerAddress) || "No Customer Address";

            // Left column rows
            // Per BIR layout, buyer info is: Registered Name, TIN, Business Address
            // (under a "Sold To:" header).
            // Left values start at x=115 (see renderColumn call below); wrap to 240
            // so they stop before the right column (which starts at x=365).
            const leftValueWrap = 240;
            // Note: in this system the B2B customer's name IS the registered business
            // name (there is no separate "registered name" field), so "Sold To:" and
            // "Registered Name:" both use the customer name.
            const leftRows = [
                ['Sold To:', doc.splitTextToSize(`${decrypt(customerName)}`, leftValueWrap)],
                ['Registered Name:', doc.splitTextToSize(`${decrypt(customerName)}`, leftValueWrap)],
                ['TIN:', wrapTextToWidth(`${decrypt(b2b.tin) || ''}`, leftValueWrap)],
                ['Business Address:', doc.splitTextToSize(`${customerAddress}`, leftValueWrap)],
                ['Remarks:', wrapTextToWidth(`${handleNull(documentDetails.remark) || ''}`, leftValueWrap)],
            ];
            // Right column values start at x=450. Wrap them to stop before the
            // info box / table right border (box right edge is at pageWidth - 30)
            // with a small pad so the text never touches or exceeds the border.
            const rightValueX = 420;
            const rightValueMaxWidth = pageWidth - 30 - rightValueX - 8;
            const rightRows = [
                ['Date:', wrapTextToWidth(moment(documentDetails.document_date).format('YYYY-MM-DD'), rightValueMaxWidth)],
                ['P.O. No.:', wrapTextToWidth(documentDetails.oc_ref_no, rightValueMaxWidth)],
                ['Terms:', wrapTextToWidth(documentDetails.payment_term_id.label, rightValueMaxWidth)],
            ];

            // Line height used by jsPDF when rendering multi-line text blocks.
            // Keep this >= the font's rendered line spacing so wrapped lines
            // (e.g. a 2-line address) never overlap the next row's text.
            const infoWrapLineHeight = 10;
            const infoRowPadding = 7;

            const renderColumn = (rows, labelX, valueX) => {
                let y = infoTop;
                rows.forEach(([label, valueLines]) => {
                    doc.setFontStyle("bold");
                    doc.text(label, labelX, y);
                    doc.setFontStyle("normal");
                    doc.text(valueLines, valueX, y, { lineHeightFactor: 1.25 });
                    // Advance by the full height of the wrapped block plus a
                    // small gap, so rows auto-adjust and never overlap.
                    const blockHeight = valueLines.length * infoWrapLineHeight;
                    y += Math.max(infoRowGap, blockHeight + infoRowPadding);
                });
                return y;
            };

            // Value column moved to x=115 so the longer BIR labels
            // ("Registered Name:", "Business Address:") don't overlap the values.
            const leftBottomY = renderColumn(leftRows, 35, 115);
            const rightBottomY = renderColumn(rightRows, 365, rightValueX);
            const infoBottomY = Math.max(leftBottomY, rightBottomY);

            // Draw the box around the company info, sized to fit the content.
            doc.setDrawColor(0, 0, 0); // Black color
            doc.setLineWidth(1);
            doc.rect(31, 85, pageWidth - 62, (infoBottomY - 85) + 5);

            // Start the table just below the info box, with a little breathing room.
            const othsinTableStartY = infoBottomY + 12;

            function formatNumber(value) {
                if (!value) return '0.00';
                return parseFloat(value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            }

            // Table Data
            const tableColumn = isPIML ? [
                { header: 'Item No.', dataKey: 'barcode' },
                { header: 'Quantity', dataKey: 'quantity' },
                { header: 'Unit', dataKey: 'unit_name' },
                { header: 'Description', dataKey: 'product_name' },
            ] : [
                { header: 'Item No.', dataKey: 'barcode' },
                { header: 'Item Description', dataKey: 'product_name' },
                { header: 'Quantity', dataKey: 'quantity' },
                { header: 'Unit', dataKey: 'unit_name' },
            ];
            tableColumn.push(
                { header: 'Unit Price', dataKey: 'price' },
                { header: 'Line Discount', dataKey: 'discount' }
            );
            // Normalize order_source so comparisons are robust regardless of
            // casing or separator. The API (DocumentSerializer) humanizes/upcases
            // the stored snake_case value ("liquidation" -> "LIQUIDATION",
            // "barter_tool" -> "BARTER TOOL"), but normalizing here guards against
            // raw/unserialized values ever reaching this printout.
            const normalizeOrderSource = (value) =>
                String(value || '').trim().toUpperCase().replace(/[_\s]+/g, ' ');
            const orderSource = normalizeOrderSource(documentDetails.order_source);
            const isLiquidation = orderSource === 'LIQUIDATION';
            const isBarterTool = ['BARTER TOOL', 'BARTER TOOL 3P'].includes(orderSource);

            //Use invoice total if SI from LIQ
            if (isLiquidation) {
                tableColumn.push({ header: 'Amount', dataKey: 'invoice_total' })
            } else if (isBarterTool) {
                tableColumn.push({ header: 'Amount', dataKey: 'barter_tool_gross' })
            } else {
                tableColumn.push({ header: 'Amount', dataKey: 'subtotal' })
            }

            if (isPIML) {
                const descriptionIndex = tableColumn.findIndex(col => col.header === 'Description');

                tableColumn.splice(descriptionIndex + 1, 0,
                    { header: 'Size', dataKey: 'size' },
                    { header: 'Color', dataKey: 'color' }
                );

                const descriptionColumn = tableColumn.find(col => col.header === 'Description');
                if (descriptionColumn) {
                    descriptionColumn.dataKey = 'style_name';
                }
            }
            function extractValues(data, keys) {
                return data.map(row => {
                    const newRow = {};
                    keys.forEach(column => {
                        if (row.hasOwnProperty(column.dataKey)) {
                            if (column.dataKey === 'price') {
                                newRow[column.dataKey] = formatNumber(row[column.dataKey]);
                            } else if (column.dataKey === 'subtotal') {
                                //No need to add trade discount >> see document_line serializer
                                newRow[column.dataKey] = formatNumber(Number(row[column.dataKey]));
                            } else if (column.dataKey === 'invoice_total') {
                                // LIQUIDATION maps the Amount column to invoice_total,
                                // which equals (qty*price - line discount). It is only
                                // populated for interco liquidation lines
                                // (reference_7 == 'Interco Tool'); for non-interco
                                // liquidation it is stored as 0. When it's 0, fall back
                                // to net_amount (also qty*price - line discount, trade
                                // discount NOT removed) so the Amount column shows the
                                // line value net of line discount and the trade discount
                                // stays as the separate "Invoice Discount" total.
                                // net_amount == subtotal + trade_discount for these lines.
                                const invoiceTotal = Number(row[column.dataKey]);
                                let amountValue;
                                if (invoiceTotal !== 0) {
                                    amountValue = invoiceTotal;
                                } else if (row.net_amount != null && Number(row.net_amount) !== 0) {
                                    amountValue = Number(row.net_amount);
                                } else {
                                    // Last-resort reconstruction: net of line discount
                                    // = subtotal + trade_discount.
                                    amountValue = Number(row.subtotal || 0) + Number(row.trade_discount || 0);
                                }
                                newRow[column.dataKey] = formatNumber(amountValue);
                            } else if (column.dataKey === 'barter_tool_gross') {
                                newRow[column.dataKey] = formatNumber(Number(row[column.dataKey]));
                            } else if (column.dataKey === 'discount') {
                                newRow[column.dataKey] = formatNumber(Number(row[column.dataKey]));
                            } else {
                                newRow[column.dataKey] = row[column.dataKey];
                            }
                        }
                    });
                    return newRow;
                });
            }

            const extractedData = extractValues(tableData, tableColumn);

            // let vat_exempt = "0.00"
            // let total_amount = "0.00"
            // let zero_rated = "0.00"

            const roundTo2 = (n) => Math.round(Number(n || 0) * 100) / 100;
            let printGrossNetOfLineDiscount = Number(summaryData.gross_amount) - Number(summaryData.item_discount);
            let printInvoiceDiscount = Number(documentDetails.amount_header_discount) + Number(documentDetails.trade_discount);
            let printNetSales = Number(summaryData.net_amount);
            let barterVatAmount = null;
            let barterNetOfVat = null;

            if (isBarterTool) {
                // Use the line amounts the barter tool generator writes, not qty x price:
                //   invoice_total  = net sales of the line (gross less line discount)
                //   trade_discount = commission on those net sales
                // Net = invoice_total - trade_discount, which equals the raw line subtotal
                const sumOf = (fn) => tableData.reduce((sum, row) => sum + Number(fn(row) || 0), 0);
                const linesNetOfLineDiscount = sumOf(row => row.invoice_total);
                const linesTradeDiscount = sumOf(row => row.trade_discount);
                const headerDiscount = Number(documentDetails.amount_header_discount || 0);

                printGrossNetOfLineDiscount = roundTo2(linesNetOfLineDiscount);
                printInvoiceDiscount = roundTo2(headerDiscount + linesTradeDiscount);
                printNetSales = roundTo2(printGrossNetOfLineDiscount - printInvoiceDiscount);
                const linesTax = roundTo2(sumOf(row => row.tax_amount));
                barterVatAmount = linesTax !== 0 ? linesTax : Number(documentDetails.tax_amount || 0);
                barterNetOfVat = roundTo2(printNetSales - barterVatAmount);
            }

            let vatableSales = printNetSales
            let vatExemptSales = 0
            let zeroRated = 0
            let vatAmount = '0.00'
            if (documentDetails.party_tax_type == 'V') {
                if (isBarterTool) {
                    vatableSales = barterNetOfVat
                    vatAmount = barterVatAmount
                } else if (isLiquidation) {
                    vatableSales = Number(documentDetails.net_amount_without_tax)
                    vatAmount = Number(documentDetails.tax_amount)
                } else {
                    vatableSales = summaryData.vatables
                    vatAmount = summaryData.vat_amount
                }
            } else if (documentDetails.party_tax_type == 'X') {
                vatableSales = 0
                vatExemptSales = printNetSales
            } else if (documentDetails.party_tax_type == 'Z') {
                vatableSales = 0
                zeroRated = printNetSales
            }
            const withholdingBase = Number(vatableSales || vatExemptSales || zeroRated || 0);
            const withholdingAmount = withholdingBase * withholdingRate;

            //Totals
            const totalsData = [
                { label: 'Total Sales, Net of Line Discount', value: formatNumber(printGrossNetOfLineDiscount) },
                { label: 'Less: Invoice Discount', value: formatNumber(printInvoiceDiscount) },
                { label: 'Net Sales', value: formatNumber(printNetSales) }
            ];

            //Vat Calculations
            const vatCalculationsData = [
                { label: 'Total Sales (VAT Inclusive)', value: formatNumber(printNetSales) },
                { label: 'Less VAT', value: formatNumber(vatAmount) },
                { label: 'Amount NET of VAT', value: formatNumber(vatableSales || vatExemptSales || zeroRated) },
                { label: 'Less: SC/PWD Discount', value: '0.00' },
                { label: 'Add: VAT', value: formatNumber(vatAmount) },
                { label: 'Amount Due', value: formatNumber(printNetSales) },
                { label: 'Less: Withholding Tax', value: formatNumber(withholdingAmount) },
                { label: 'TOTAL AMOUNT DUE', value: formatNumber(printNetSales - withholdingAmount) }
            ];

            const vatDetails = [
                { label: 'VATable Sales', value: formatNumber(vatableSales) },
                { label: 'VAT', value: formatNumber(vatAmount) },
                { label: 'Zero-Rated Sales', value: formatNumber(zeroRated) },
                { label: 'VAT-Exempt Sales', value: formatNumber(vatExemptSales) },
            ];

            // Body = items + spacer row + totals rows (+ trailing filler rows).
            // The single-page layout keeps the original look (tall spacer and
            // filler rows pad the totals toward the VAT panel). The multi-page
            // layout drops the filler rows so nothing spills onto a trailing page.
            const buildBodyRows = (multiPage) => {
                const totalsRows = totalsData.map(total => isPIML
                    ? { barcode: '', quantity: '', unit_name: '', style_name: '', size: '', color: '', price: total.label, discount: '', subtotal: total.value }
                    : { barcode: '', product_name: '', quantity: '', unit_name: '', price: total.label, discount: '', subtotal: total.value });
                return [
                    ...extractedData,
                    {},
                    ...totalsRows,
                    ...(multiPage ? [] : [{}, {}, {}]),
                ];
            };
            const SINGLE_PAGE_SPACER = 105;
            const MULTI_PAGE_SPACER = 12;
            const lastColumn = isPIML ? 8 : 6
            const labelColumn = isPIML ? 6 : 4

            // Row indices of the totals block within extractedDataWithTotals.
            // Layout: [...extractedData, {} separator, totalsData[0..2], {}, {}, {}]
            const totalsFirstRow = extractedData.length + 1; // Total Sales, Net of Line Discount
            const totalsNetSalesRow = extractedData.length + totalsData.length; // Net Sales
            const boldTotalsCells = [
                { row: totalsFirstRow, column: labelColumn },
                { row: totalsFirstRow, column: lastColumn },
                { row: totalsNetSalesRow, column: labelColumn },
                { row: totalsNetSalesRow, column: lastColumn },
            ];

            const cellsToUnderline = [
                // No rule above "Total Sales, Net of Line Discount" — the provided
                // new format shows no line there (the previous entry drawing a line
                // at the top of the first totals row has been removed).
                { row: extractedData.length + totalsData.length + 4, column: lastColumn, type: 'single' },
            ];

            const columnStyles = isPIML ? {
                1: { halign: 'right' }, 3: { halign: 'left' },
                4: { halign: 'left' }, 5: { halign: 'left' },
                6: { halign: 'right' },
            } : {
                1: { halign: 'left' }, 2: { halign: 'right', cellWidth: 42 },
                3: { halign: 'left', cellWidth: 34 }, 4: { halign: 'right', cellWidth: 90 },
                5: { halign: 'right', cellWidth: 72 }, 6: { halign: 'right', cellWidth: 70 },
            };

            if (isPIML) {
                columnStyles[7] = { halign: 'right' };
                columnStyles[8] = { halign: 'right' };
            }
            // Track the top Y of the item table on each page so the enclosing
            // box can be drawn per page. A single doc.rect() cannot span pages,
            // which is what broke multi-page invoices.
            const itemTablePageTops = {};
            const itemTableFirstPage = doc.internal.getCurrentPageInfo().pageNumber;
            // Last page that rendered an actual item/totals body row, and the Y
            // where that content ended. Used to avoid drawing a box around a page
            // that only received the repeating header.
            let lastBodyPage = itemTableFirstPage;
            let lastBodyY = othsinTableStartY;

            // Table options shared by the real render and the measuring pass, so the
            // measurement always matches what is actually drawn.
            const itemTableBaseOptions = {
                theme: 'plain',
                head: [tableColumn.map(col => col.header)],
                styles: { fontSize: 8 },
                margin: { left: 31, right: 31, top: 100, bottom: 200 },
                headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], halign: 'center' },
                bodyStyles: { halign: 'center' },
                columnStyles: columnStyles,
                tableLineColor: [0, 0, 0],
                tableLineWidth: 0,
                pageBreak: 'auto',
                rowPageBreak: 'avoid', // never split a wrapped item row across pages
            };
            const makeDidParseCell = (spacerHeight) => function (data) {
                if (data.section === 'body' && data.row.index === extractedData.length) {
                    // Spacer row between the item lines and the totals block.
                    data.cell.styles.minCellHeight = spacerHeight;
                }
                if (!isPIML && data.column.index === 1) {
                    data.cell.styles.cellWidth = 150;
                }
                if (data.section === 'body') {
                    const shouldBold = boldTotalsCells.find(
                        cell => cell.row === data.row.index && cell.column === data.column.index
                    );
                    if (shouldBold) {
                        data.cell.styles.fontStyle = 'bold';
                    }

                    const totalsRowStart = extractedData.length + 1;
                    const totalsRowEnd = extractedData.length + totalsData.length;
                    const isTotalsRow = data.row.index >= totalsRowStart && data.row.index <= totalsRowEnd;
                    if (isTotalsRow && data.column.index === labelColumn) {
                        data.cell.colSpan = 2;
                        data.cell.styles.halign = 'right';
                    }
                }
            };

            // Decide the layout from a real measurement instead of a guess: render
            // the original single-page variant (tall spacer + filler rows) on a
            // scratch PDF. If it fits on one page, keep that look. If it spills
            // onto more pages, use the compact multi-page variant.
            const scratchDoc = new jsPDF('p', 'pt', 'a4');
            scratchDoc.autoTable({
                ...itemTableBaseOptions,
                body: buildBodyRows(false).map(row => Object.values(row)),
                startY: othsinTableStartY,
                didParseCell: makeDidParseCell(SINGLE_PAGE_SPACER),
            });
            // The VAT panel + conditions text form one block (~101pt table + ~60pt
            // of text). It must end above the footer block.
            const VAT_BLOCK_HEIGHT = 170;
            const PAGE_CONTENT_BOTTOM = pageHeight - 60;
            // Keep the original single-page look only when the items fit on one page
            // AND the VAT panel still fits below them. Otherwise use the compact
            // layout (small spacer, no filler rows) so no near-empty page appears.
            const singleLayoutVatY = Math.max(scratchDoc.lastAutoTable.finalY, othsinTableStartY + 220);
            const useSingleLayout = scratchDoc.internal.getNumberOfPages() === 1
                && (singleLayoutVatY + VAT_BLOCK_HEIGHT) <= PAGE_CONTENT_BOTTOM;
            const useCompactLayout = !useSingleLayout;
            const extractedDataWithTotals = buildBodyRows(useCompactLayout);

            // Single table
            doc.autoTable({
                ...itemTableBaseOptions,
                body: extractedDataWithTotals.map(row => Object.values(row)),
                startY: othsinTableStartY,
                didParseCell: makeDidParseCell(useCompactLayout ? MULTI_PAGE_SPACER : SINGLE_PAGE_SPACER),
                didDrawCell: function (data) {
                    // Track the last page that actually rendered a BODY row and the
                    // Y where the last body cell ended. autoTable can start a fresh
                    // page and draw only the repeating header (no body rows) when
                    // content lands right at a page boundary; such a page must NOT
                    // get an item box drawn around empty space.
                    if (data.section === 'body') {
                        const pg = doc.internal.getCurrentPageInfo().pageNumber;
                        if (pg > lastBodyPage) {
                            // First body cell on a new page: forget the previous
                            // page's Y, otherwise it would stay larger than anything
                            // on this page and the content end would be overstated.
                            lastBodyPage = pg;
                            lastBodyY = 0;
                        }
                        const cellBottom = data.cell.y + data.cell.height;
                        if (pg === lastBodyPage && cellBottom > lastBodyY) {
                            lastBodyY = cellBottom;
                        }
                    }
                    const shouldUnderline = cellsToUnderline.find(
                        cell => cell.row === data.row.index && cell.column === data.column.index
                    );

                    if (shouldUnderline) {
                        const { x, y, width } = data.cell;
                        doc.setDrawColor(0);
                        doc.setLineWidth(0.5);

                        if (shouldUnderline.type === 'single') {
                            doc.line(x, y, x + width, y);
                        }
                    }
                    if (data.section === "head" && data.row.index === 0) {
                        const { y, height } = data.cell;
                        const fullTableWidth = data.table.columns.reduce((sum, col) => sum + col.width, 0);
                        doc.setDrawColor(0);
                        doc.setLineWidth(0.5);
                        doc.line(
                            data.table.settings.margin.left,
                            y + height,
                            data.table.settings.margin.left + fullTableWidth,
                            y + height
                        );
                    }

                },
                didDrawPage: (data) => {
                    const pageCount = doc.internal.getNumberOfPages();
                    const currentPage = doc.internal.getCurrentPageInfo().pageNumber;
                    // Add header on each page
                    addHeader(doc, siteData, companyData, documentDetails, xLeftKey, pageWidth, currentPage, pageCount);
                    // Add footer on each page
                    addFooter(doc, pageWidth, pageHeight, currentPage, pageCount);
                    // Record where the item table started on each page so the
                    // enclosing box can be drawn per page (a single rect cannot
                    // span multiple pages). data.table.startPageNumber/pageNumber
                    // let us detect continuation pages.
                    itemTablePageTops[currentPage] = (currentPage === itemTableFirstPage)
                        ? (othsinTableStartY - 4)
                        : (data.settings.margin.top);
                },
            });
            // The true end of the item/totals content is the last page/Y where a
            // body row was actually drawn (not a page that only got the header).
            const itemTableEndPage = lastBodyPage;
            const itemTableFinalY = lastBodyY;
            // Anchor the VAT block right after the real end of content. The "+220"
            // padding is a single-page device to push the VAT block toward the
            // bottom; on a multi-page invoice it can shove the VAT block onto an
            // otherwise-empty new page, so only pad when single-page.
            let vatTableY = useCompactLayout
                ? itemTableFinalY + 12
                : Math.max(itemTableFinalY, othsinTableStartY + 220);

            // If the VAT block (VAT_BLOCK_HEIGHT, defined with the layout decision)
            // still won't fit under the totals on the last item page, start it on a
            // fresh page so it renders at the top instead of overflowing.
            let vatMovedToNewPage = false;
            if (vatTableY + VAT_BLOCK_HEIGHT > PAGE_CONTENT_BOTTOM) {
                doc.addPage();
                vatMovedToNewPage = true;
                // A manually added page does not get the item table's didDrawPage
                // header/footer, so draw them here. Place the VAT block near the
                // top of the new page.
                const newPage = doc.internal.getNumberOfPages();
                const pageCount = newPage;
                addHeader(doc, siteData, companyData, documentDetails, xLeftKey, pageWidth, newPage, pageCount);
                addFooter(doc, pageWidth, pageHeight, newPage, pageCount);
                vatTableY = 95; // below the running company header
            }
            // Record the page the VAT block will actually render on.
            const vatStartPage = doc.internal.getNumberOfPages();
            const tableBody = [];
            const maxRows = Math.max(vatCalculationsData.length, 7);

            for (let i = 0; i < maxRows; i++) {
                const vatDetail = vatDetails[i] || { label: '', value: '' };
                const vatCalc = vatCalculationsData[i] || { label: '', value: '' };

                tableBody.push([
                    vatDetail.label,
                    vatDetail.value,
                    '',
                    vatCalc.label,
                    vatCalc.value
                ]);
            }
            const vatCellsToUnderline = [
                { row: 2, column: 4, type: 'single' },
                { row: 5, column: 4, type: 'single' },
                { row: 7, column: 4, type: 'single' }, // under Less: Withholding Tax, above TOTAL AMOUNT DUE

            ];
            // Create the table
            doc.autoTable({
                theme: 'plain',
                head: [['', '', '', '', '']], // Empty header for spacing
                body: tableBody,
                startY: vatTableY,
                pageBreak: 'avoid', // VAT block is pre-fitted; keep it on one page
                tableLineColor: [0, 0, 0],
                tableLineWidth: 0,
                styles: {
                    fontSize: 8,
                    cellPadding: { top: 1, right: 2, bottom: 1, left: 2 },
                },
                margin: { left: 33, right: 33 },
                columnStyles: {
                    0: { cellWidth: 130, halign: 'left' },
                    1: { cellWidth: 105, halign: 'right' },
                    2: { cellWidth: 30 },
                    3: { cellWidth: 179, halign: 'left' },
                    4: { cellWidth: 85, halign: 'right' }
                },
                willDrawCell: function (data) {
                    const shouldUnderlineVat = vatCellsToUnderline.find(
                        cell => cell.row === data.row.index && cell.column === data.column.index
                    );

                    if (shouldUnderlineVat) {
                        const { x, y, width } = data.cell;
                        doc.setDrawColor(0);
                        doc.setLineWidth(0.5);

                        if (shouldUnderlineVat.type === 'single') {
                            doc.line(x, y, x + width, y);
                        } else if (shouldUnderlineVat.type === 'double') {
                            doc.line(x, y - 1, x + width, y - 1);
                            doc.line(x, y + 1, x + width, y + 1);
                        }
                    }

                    if (data.row.index === tableBody.length - 1 && (data.column.index === 3 || data.column.index === 4)) {
                        doc.setFont('helvetica', 'bold');
                    }

                },
            });
            const vatPanelBottom = doc.lastAutoTable.finalY + 3;
            const vatPanelDivider = vatTableY;
            const finalPage = doc.internal.getNumberOfPages();
            const boxLeft = 31;
            const boxRight = pageWidth - 31;
            const boxWidth = pageWidth - 62;
            const pageBottomLimit = pageHeight - 90; // keep clear of the footer block

            // vatMovedToNewPage is the authoritative signal (set when we explicitly
            // broke to a fresh page because the VAT block wouldn't fit).
            const vatOnOwnPage = vatMovedToNewPage;

            // Draw the enclosing box per page. A single rect cannot span multiple
            // pages, so for each item page we draw a box from that page's table
            // top down to the content bottom for that page.
            const pagesWithItems = Object.keys(itemTablePageTops).map(Number).sort((a, b) => a - b);
            pagesWithItems.forEach((pageNum) => {
                // Never draw an item box on a page past the last page that
                // actually rendered item rows (such a page only got the repeating
                // header, so a box there would wrap empty space).
                if (pageNum > itemTableEndPage) {
                    return;
                }
                doc.setPage(pageNum);
                // Re-apply pen color/width after switching pages for long pages
                doc.setDrawColor(0, 0, 0);
                doc.setLineWidth(0.8);
                const top = itemTablePageTops[pageNum];
                if (pageNum === itemTableEndPage && !vatOnOwnPage) {
                    // Items + VAT panel share this page: enclose both and draw
                    // the divider between the item section and the VAT section.
                    doc.rect(boxLeft, top, boxWidth, vatPanelBottom - top);
                    doc.line(boxLeft, vatPanelDivider, boxRight, vatPanelDivider);
                } else if (pageNum === itemTableEndPage && vatOnOwnPage) {
                    // Last item page but VAT moved to its own page: box only wraps
                    // the items down to where they actually ended (no empty space).
                    doc.rect(boxLeft, top, boxWidth, (itemTableFinalY + 3) - top);
                } else {
                    // Continuation page full of items: box runs to the bottom limit.
                    doc.rect(boxLeft, top, boxWidth, pageBottomLimit - top);
                }
            });

            // When the VAT block was moved to its own page, draw a compact box
            // around just the VAT panel (top of that page) instead of a tall
            // empty rectangle.
            if (vatOnOwnPage) {
                doc.setPage(vatStartPage);
                doc.setDrawColor(0, 0, 0);
                doc.setLineWidth(0.8);
                const vatBoxTop = vatTableY - 6;
                doc.rect(boxLeft, vatBoxTop, boxWidth, vatPanelBottom - vatBoxTop);
            }
            doc.setPage(finalPage);

            const conditionsTop = vatPanelBottom + 12;
            doc.setFontSize(6);
            doc.setFontStyle('normal');
            doc.text('Customer acknowledges receipt of the above items in good order and condition.', 40, conditionsTop + 11);
            doc.text('All items described herein shall remain to be property of this Company until fully paid for. All unpaid portion will be charged a penalty of 5% per month.', 40, conditionsTop + 20);
            doc.text('Parties agree to submit to the jurisdiction of the court of the City of Manila in case of legal action arising from this transaction.', 40, conditionsTop + 29);
            doc.setFontSize(7);
            doc.setFontStyle('bold');
            doc.text('THIS DOCUMENT IS VALID FOR CLAIM OF INPUT TAX', pageWidth / 2, conditionsTop + 47, { align: 'center' });

            const totalPages = doc.internal.getNumberOfPages();
            const titleRightEdge = pageWidth - 40;
            doc.setFontSize(6);
            doc.setFontStyle('normal');
            doc.setTextColor(110, 110, 110);
            for (let p = 1; p <= totalPages; p++) {
                doc.setPage(p);
                doc.text(`PAGE ${p}/${totalPages}`, titleRightEdge, 32, { align: 'right' });
            }
            doc.setTextColor(0, 0, 0);
            doc.setPage(totalPages);

            // Generate the PDF as a data URI
            //var pdfDataUri = doc.output('datauristring');

            // Open the PDF in a new tab
            // var win = window.open();
            // win.document.write('<iframe src="' + pdfDataUri + '" style="border: none; width: 100%; height: 100%;"></iframe>');

            // Save the PDF
            // doc.save('invoice.pdf');
            let pdfWindow = window.open(doc.output('bloburl'), '_blank');
            const detectBrowser = () => {
                const agent = window.navigator.userAgent.toLowerCase();
                if (agent.indexOf('edg') > -1) return 'Microsoft Edge';
                if (agent.indexOf('chrome') > -1) return 'Google Chrome';
                if (agent.indexOf('safari') > -1) return 'Safari';
                return 'Not Supported Browser';
            };

            const detectColorScheme = () => {
                if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                    return 'dark';
                }
                return 'light';
            };

            const browserName = detectBrowser();
            const colorScheme = detectColorScheme();
            const browserColors = {
                'Google Chrome': {
                    dark: 'rgb(51, 54, 57)',
                    light: 'white'
                },
                'Microsoft Edge': {
                    dark: 'rgb(59, 59, 59)',
                    light: 'rgb(247, 247, 247)'
                },
                'Safari': {
                    dark: 'rgb(44, 44, 44)',
                    light: 'white'
                },
                'default': {
                    dark: 'rgb(30, 33, 36)',
                    light: 'white'
                }
            };
            const getBackgroundColor = () => {
                const browserColorConfig = browserColors[browserName] || browserColors['default'];
                return browserColorConfig[colorScheme];
            };

            if (!isPrinted) {
                pdfWindow.addEventListener('load', () => {
                    const printButton = pdfWindow.document.createElement('button');
                    printButton.style.position = 'fixed';
                    printButton.style.top = browserName == 'Microsoft Edge' ? '2px' : '10px';
                    printButton.style.right = '10px';
                    printButton.style.zIndex = '9999';
                    printButton.style.marginRight = '44px';
                    printButton.style.backgroundColor = getBackgroundColor();
                    printButton.style.border = 'none';
                    printButton.style.padding = browserName == 'Microsoft Edge' ? '10px 40px' : '10px 20px';
                    printButton.style.cursor = 'pointer';
                    printButton.style.color = colorScheme == 'dark' ? 'white' : 'black'
                    printButton.style.fontSize = '15px'

                    const fontAwesomeLink = pdfWindow.document.createElement('link');
                    fontAwesomeLink.rel = 'stylesheet';
                    fontAwesomeLink.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css';
                    pdfWindow.document.head.appendChild(fontAwesomeLink);

                    printButton.innerHTML = '<i class="fas fa-print"></i> Print';

                    printButton.addEventListener('click', () => {
                        pdfWindow.print()
                        this.create_action_history('Print Document', documentDetails.id)
                    });
                    pdfWindow.document.body.appendChild(printButton);
                });
            }

            component_x.spinning = false;

        },
        async create_action_history(action, doc_no) {
            var actionHistoryPayload = {
                action: action,
                action_at: moment(new Date()),
                action_by: secureStorage.getItem("userName"),
                document_id: doc_no,
                status: "A"
            }
            await HTTPRequest.postRequest(this.endPoint + 'document_action_histories/', null, actionHistoryPayload)
        },
    }
};

export default printOthsinWithholding; // export the mixin
